import { makeStyles } from '@material-ui/core/styles';

import SearchIcon from '../../../images/search-icon.svg';

const heightBySize = size => {
  switch (size) {
    case 'small':
      return 32;
    case 'medium':
      return 40;
    case 'large':
      return 48;
    case 'none':
      return 'none';
    default:
      return 32;
  }
};

const useStyles = makeStyles(theme => ({
  controlWrapper: {
    background: theme.customBackground.white,
    border: props => {
      if (props.inlineSearch) {
        return 'none';
      }
      if (props.error) {
        return theme.customBorders.error;
      }
      if (props.menuIsOpen) {
        return theme.customBorders.primary;
      }
      return theme.customBorders.gray300;
    },
    borderRadius: 3,
    boxShadow: theme.customShadows.selectDropdown,
    cursor: 'pointer',
    maxHeight: ({ isMulti, size }) => (isMulti ? 'none' : heightBySize(size)),
    minHeight: ({ size }) => heightBySize(size),
    padding: theme.spacing(0.5, 2, 0.5, 2.5),
    transition: 'border-color 0.3s ease',
  },
  inlineSearch: {
    background: theme.palette.common.gray100,
    backgroundImage: `url("${SearchIcon}")`,
    backgroundPositionX: theme.spacing(2),
    backgroundPositionY: 'center',
    backgroundRepeat: 'no-repeat',
    paddingLeft: theme.spacing(5.5),
  },
}));

export default useStyles;
